// Centralized cache mode flags
// Controls whether app-level caches should be used.

type CacheMode = 'on' | 'off' | 'auto';

function readEnvCacheMode(): CacheMode {
  const raw = (import.meta as any)?.env?.VITE_CACHE_MODE as string | undefined;
  if (!raw) return 'auto';
  const val = raw.toLowerCase();
  if (val === 'on' || val === 'off' || val === 'auto') return val;
  return 'auto';
}

function readEnvDisableFlag(): boolean {
  const raw = (import.meta as any)?.env?.VITE_DISABLE_CACHE as string | undefined;
  return raw === 'true';
}

// Allows quick, runtime overrides in the browser without rebuilds (dev support)
function readRuntimeOverride(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    const override = window.localStorage?.getItem('dev.cache.disabled');
    return override === 'true';
  } catch {
    return false;
  }
}

export function isCacheDisabled(): boolean {
  // Priority: runtime override > explicit disable flag > cache mode
  if (readRuntimeOverride()) return true;
  if (readEnvDisableFlag()) return true;

  const mode = readEnvCacheMode();
  if (mode === 'off') return true;
  return false;
}

export function addCacheBuster(url: string): string {
  if (!isCacheDisabled()) return url;
  try {
    const u = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    u.searchParams.set('t', Date.now().toString());
    return u.pathname + u.search + u.hash;
  } catch {
    // Fallback for relative paths or unusual inputs
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}t=${Date.now()}`;
  }
}

export function noStoreRequestInit(): RequestInit {
  // Helper to consistently set fetch no-store when cache disabled
  if (!isCacheDisabled()) return {};
  return {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache'
    }
  } as RequestInit;
}


